import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { Link } from "react-router-dom";

const Brand3 = ({ data }) => {
  // State for component styling
  const [backgroundColor, setBackgroundColor] = useState("");
  const [titleColor, setTitleColor] = useState("");
  const [titleFont, setTitleFont] = useState("");
  const [cornerRadius, setCornerRadius] = useState("0"); // Fixed typo and removed duplicate
  const [itemMargin, setItemMargin] = useState("");
  const [itemPadding, setItemPadding] = useState("");
  const [labelPosition, setLabelPosition] = useState("");
  const [noOfColumn, setNoOfColumn] = useState("5");
  const [webHeight, setWebHeight] = useState("");
  const [textAlignment, setTextAlignment] = useState("");
  const [titleAlignment, setTitleAlignment] = useState("");
  const [title, setTitle] = useState("");
  const [height, setHeight] = useState("100");

  const component = data || {};
  const categories = data?.get_home_component_details?.content || [];

  useEffect(() => {
    if (component) {
      setBackgroundColor(component.web_background_color || "");
      setTitleColor(component.web_title_color || "");
      setTitleFont(component.web_title_font || "");
      setCornerRadius(component.corner_radius || "0");
      setItemMargin(component.item_margin || "");
      setItemPadding(component.item_padding || "");
      setLabelPosition(component.label_position || "");
      setNoOfColumn(component.no_of_column || "5");
      setTextAlignment(component.text_alignment || "");
      setWebHeight(component.web_height || "");
      setTitleAlignment(component.title_alignment || "");
      setTitle(component.title || "");
      setHeight(component.web_height || "100");
    }
  }, [data]);

  // Map noOfColumn to Bootstrap column classes
  const getColumnClass = (columns) => {
    switch (columns) {
      case "1":
        return "col-12";
      case "2":
        return "col-6 col-sm-6 col-md-6 col-lg-6";
      case "3":
        return "col-12 col-sm-6 col-md-4 col-lg-4";
      case "4":
        return "col-6 col-sm-6 col-md-4 col-lg-3";
      case "5":
        return "col-6 col-sm-6 col-md-4 col-lg-2-4"; // Custom width for 5 columns (2.4 = 12/5)
      case "6":
        return "col-6 col-sm-6 col-md-4 col-lg-2";
      case "7":
        return "col-6 col-sm-6 col-md-4 col-lg-1-7"; // Custom width for 7 columns
      case "8":
        return "col-6 col-sm-6 col-md-3 col-lg-1-5"; // Custom width for 8 columns
      case "9":
        return "col-6 col-sm-6 col-md-3 col-lg-1-3"; // Custom width for 9 columns
      default:
        return "col-12";
    }
  };

  // Normalize color from ARGB to RGBA
  const normalizeColor = (colorString) => {
    if (!colorString) return "";
    const match = colorString.match(/0x([0-9a-fA-F]{8})/);
    if (!match) return colorString;
    const hex = match[1];
    return `#${hex.slice(2)}${hex.slice(0, 2)}`;
  };

  // Truncate names for mobile and desktop
  const truncateNameMobile = (name) => {
    return name.length > 6 ? name.substring(0, 6) + "..." : name;
  };

  const truncateNameDesktop = (name) => {
    return name.length > 15 ? name.substring(0, 15) + "..." : name;
  };

  return (
    <div
      className="px-2 py-3 w-100"
      style={{ backgroundColor: backgroundColor }}
      id={data?._id}
    >
      {/* Desktop View: Bootstrap Grid */}
      {["1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(noOfColumn) && (
        <div className="w-100">
          {/* Title Section */}
          {title && (
            <div
              className={`w-100 mb-4 ${
                titleAlignment === "center" ? "text-center" : "text-start"
              }`}
              style={{
                color: normalizeColor(titleColor),
                fontFamily: titleFont || "inherit",
              }}
            >
              <h2 className="text-lg font-semibold">{title}</h2>
            </div>
          )}

          <div className="row g-0">
            {categories.map((category) => (
              <div
                key={category.brand_auto_id}
                className={getColumnClass(noOfColumn)}
              >
                <div
                  className="d-flex justify-content-center"
                  style={{
                    margin: `${parseFloat(itemMargin)}px`,
                    padding: `${parseFloat(itemPadding)}px`,
                  }}
                >
                  <div className="d-flex align-items-center p-1 text-center w-100">
                    <Link
                      to="/brandlist"
                      state={{
                        brand_id: category.brand_auto_id,
                        brand_name: category.brand_name,
                      }}
                      className="d-flex flex-column align-items-center text-decoration-none text-inherit w-100"
                    >
                      {/* Text at the Top */}
                      {textAlignment === "beside" && labelPosition === "top" && (
                        <p className="mb-2 text-sm text-black">
                          {truncateNameDesktop(category.brand_name)}
                        </p>
                      )}

                      {/* Image Container */}
                      <div className="position-relative w-100">
                        {labelPosition === "top" && textAlignment === "over" && (
                          <p
                            className="position-absolute top-0 start-0 end-0 h-10 p-2 text-sm text-center text-white bg-black bg-opacity-50"
                            style={{
                              borderTopLeftRadius: `${parseInt(cornerRadius, 10)}px`,
                              borderTopRightRadius: `${parseInt(cornerRadius, 10)}px`,
                            }}
                          >
                            {truncateNameDesktop(category.brand_name)}
                          </p>
                        )}

                        {/* Image */}
                        <img
                          src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/brands/${category.brand_image_app}`}
                          alt={category.brand_name}
                          className="object-cover w-100"
                          style={{
                            height: `${webHeight}px`,
                            borderRadius: `${parseInt(cornerRadius, 10)}px`,
                          }}
                        />

                        {/* Text Overlay for Center */}
                        {labelPosition === "center" && textAlignment === "over" && (
                          <p
                            className="position-absolute top-0 start-0 end-0 bottom-0 d-flex align-items-center justify-content-center text-sm text-white bg-black bg-opacity-50 p-2"
                            style={{
                              height: `${webHeight}px`,
                              borderRadius: `${parseInt(cornerRadius, 10)}px`,
                            }}
                          >
                            {truncateNameDesktop(category.brand_name)}
                          </p>
                        )}

                        {/* Text Overlay at the Bottom */}
                        {labelPosition === "bottom" && textAlignment === "over" && (
                          <p
                            className="position-absolute bottom-0 start-0 end-0  p-2 mb-0 text-sm text-center text-white bg-black bg-opacity-50"
                            style={{
                              borderBottomLeftRadius: `${parseInt(cornerRadius, 10)}px`,
                              borderBottomRightRadius: `${parseInt(cornerRadius, 10)}px`,
                              height: `${parseInt(height, 10)}px`,
                            }}
                          >
                            {truncateNameDesktop(category.brand_name)}
                          </p>
                        )}
                      </div>

                      {/* Text at the Bottom */}
                      {(textAlignment === "beside" &&
                        (labelPosition === "bottom" || labelPosition === "center")) && (
                        <p className="mt-2 text-sm text-black">
                          {truncateNameDesktop(category.brand_name)}
                        </p>
                      )}
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

    </div>
  );
};

export default Brand3;